import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { BazisAutocompleteComponent } from '@bazis/form/components/base/autocomplete/autocomplete.component';
import { popperControlOptions } from '@bazis/form/models/form-element.types';

@Component({
    selector: 'app-autocomplete-inside',
    templateUrl: './autocomplete-inside.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AutocompleteInsideComponent extends BazisAutocompleteComponent implements OnInit {
    ngOnInit(): void {
        super.ngOnInit();
        this.popperOptions = {
            modifiers: [
                ...popperControlOptions.modifiers,
                {
                    name: 'offset',
                    options: {
                        offset: ({ placement }) => {
                            if (placement === 'top-start') {
                                return [0, 24];
                            } else {
                                return [0, 6];
                            }
                        },
                    },
                },
            ],
        };
    }
}
